<template>
  <div class="text-page">
    <vue-headful :title="doctitle" />
    <div
      class="position-relative"
      style="max-width: 1900px; margin-left: auto; margin-right: auto"
    >
      <b-container>
        <b-row>
          <b-col>
            <h1>Ready to partner up with Øredev?</h1>
            <p class="m-0">
              Join one of the biggest developer conferences in the Nordics and
              be top of mind in the tech industry!
            </p>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="position-relative divider-margin">
        <b-row class="text-center">
          <b-col sm="6" style="margin-bottom: 30px">
            <div class="q-card bg-mint h-100 d-flex flex-column">
              <h2>What?</h2>
              <p class="m-0">
                Øredev is an international developers conference happening
                annually in Malmö, Sweden.
              </p>
            </div>
          </b-col>
          <b-col sm="6" style="margin-bottom: 30px">
            <div class="q-card bg-purple h-100 d-flex flex-column">
              <h2>Reach?</h2>
              <p class="m-0">
                1200+ attendees<br />100+ speakers<br />120+ sessions<br />3
                days
              </p>
            </div>
          </b-col>
        </b-row>
        <b-row class="text-center">
          <b-col>
            <div class="q-card bg-lime-green" style="">
              <h2>Who?</h2>
              <p class="m-0">
                Our target audience consists of tech professionals with several
                years of experience in various roles within software development
                and tech management. They're characterized by a strong passion
                for innovation, technology, and problem-solving; driven to
                challenge the status quo, explore new ideas, and contribute to
                the advancement of their field!
              </p>
            </div>
          </b-col>
        </b-row>
        <b-img
          src="https://res.cloudinary.com/oredev/image/upload/v1743156659/2025/Footer_pages/alien_pointing.png"
          class="position-absolute display-alien"
          style="width: 243px; right: -158px; top: 43px"
          alt="A small alien pointing to the information about Reach."
        />
      </b-container>

      <b-container>
        <b-row class="divider-margin d-md-none">
          <b-col class="text-center">
            <b-img
              src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_orange.png"
              style="max-width: 100px"
              alt=""
              aria-hidden="true"
            />
          </b-col>
        </b-row>
        <DividerPink />

        <b-row style="margin-bottom: 14px">
          <b-col
            sm="6"
            class="benefit"
            v-for="(benefit, index) in benefits"
            :key="index"
          >
            <b-img :src="benefit.src" class="mb-2" alt="" aria-hidden="true" />
            <p class="m-0 pr-sm-5">{{ benefit.text }}</p>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <h2>Previous partners include:</h2>
            <p class="m-0">
              Neo4j, Sinch, CodeScene, Couchbase, Devoteam, Grafana, Riad,
              Atlassian, Oracle, Microsoft, Jayway, Sony Ericsson, Enea, SyBase,
              JavaBLACKbelt, Epsilon, Sigma, Alladin, Qi4j, Omicron, Test
              Automation FX, Prevas, Azul Systems, Det Norske Veritas,
              DevelopMentor, Informator, Endevo, Intel, SAS, Spring Source,
              Kaazing, Øresund IT, ÅF Engineering, IT Mill, Hewlet Packard, SUN
              Microsystems, Beijer Electronics, Aepona, Escenic, Infragistics,
              EDP Consult, Netviewer, Cornerstone, Projektplatsen, PMI,
              Gigaspaces, Quest Software, PC-Ware, Nohau, Ilog, BlackBerry,
              Qlik, Spree, JetBRAINS, AccuRev, Mobile Heights, K3, Nokia,
              Accenture, Tretton37, Avega Group, DevExpress, ContinuousTests,
              DatorMagazin, SwCG, InterSystems, Embarcadero, Telerik,
              Informator, Alfasoft, Aptitude, Symbio, Pluralsight, Tobii, XDIN,
              Hansoft, dexplora, InterSystems, ATIVE, King, Betsson, splunk,
              SafeNet, RavenDB, IBM, Webstep, TrueSec, Amazon Web Services,
              ipeer, Red Hat, Mozilla, Capgemini, FalconSocial, Mobenga,
              Avensia, ECRU Consulting, Data Ductus, Apptus, Lundalogik,
              Telavox, infomaker, SONY, Apptimate, presis, O'Reilly, 46 Elks,
              Softhouse, Bouvet, JustType, 4C Strategies, Signicat, Infomaker,
              Tactel, GitHub, StackOverflow, Edument, LivingIT.
            </p>
            <DividerBlue />
            <p>
              Read more about our
              <a
                href="https://drive.google.com/file/d/1KAglvyBi75jIXrKUXPeYEHTyP5JbLPpj/view?usp=drive_link"
                target="_blank"
                rel="noopener noreferrer"
                >partnership options</a
              >, and reach out to us to start a discussion about the
              opportunities.
            </p>
            <p class="m-0">
              Maisa Dabus, Conference Director -
              <a href="mailto:maisa@oredev.org">maisa@oredev.org</a>
            </p>
            <DividerGreen />
          </b-col>
        </b-row>

        <b-container fluid class="divider-margin">
          <b-row class="bg-beige py-3">
            <b-col>
              <h2 style="font-size: 24px">ØREDEV +</h2>
              <p>
                As a partner, you'll have the chance to host a side event during
                the Øredev week. Hosting an Øredev+ event offers a valuable
                opportunity to boost your company's visibility during Øredev. By
                leveraging the Øredev brand and promoting your event through our
                media channels, you'll gain exposure and become an essential
                component of the official Øredev program, increasing your
                brand's visibility.
              </p>
              <p class="m-0">
                <a
                  href="https://drive.google.com/file/d/1sPYtIUyo7GfALi8KHD79Ner7ns6Y_N26/view"
                  target="_blank"
                  rel="noopener noreferrer"
                  >More Information</a
                >
              </p>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_orange.png"
        class="position-absolute d-none d-orange-block"
        style="top: 14%; right: 3%; max-width: 8%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/planet.png"
        class="position-absolute d-none d-xl-block"
        style="top: 26%; left: 2%; max-width: 14%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_blue.png"
        class="position-absolute d-none d-xl-block"
        style="bottom: 28%; right: 4%; max-width: 8%"
        alt=""
        aria-hidden="true"
      />
    </div>
  </div>
</template>

  <script>
export default {
  name: "Partnership",
  data() {
    return {
      doctitle: "Partnership - " + this.$store.state.conferencename,
      benefits: [
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1743156751/2025/Footer_pages/Icons/icon_exposure.png",
          text: "Increase your exposure and brand recognition in the tech industry!",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1743156753/2025/Footer_pages/Icons/icon_showcase.png",
          text: "Showcase your product & service to the right target audience and generate leads.",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1743156751/2025/Footer_pages/Icons/icon_invest.png",
          text: "Invest in your employees and they will bring back new ideas to use at work!",
        },
        {
          src: "https://res.cloudinary.com/oredev/image/upload/v1743156752/2025/Footer_pages/Icons/icon_people.png",
          text: "Connect with a high qualified tech audience of developers and decision makers.",
        },
      ],
    };
  },
};
</script>

  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.q-card {
  padding: 32px 15px;
  @media (min-width: 768px) {
    padding: 54px 70px;
  }
  h2 {
    font-size: 24px;
    margin-bottom: 16px;
    line-height: 31px;
  }
  p {
    font-weight: 500;
  }
}
.display-alien {
  display: none;
  @media (min-width: 1175px) {
    display: block;
  }
}

.benefit {
  margin-bottom: 42px;
  img {
    max-width: 56px;
    display: block;
    margin-left: auto;
    margin-right: auto;

    @media (min-width: 576px) {
      margin-left: 0;
      margin-right: 0;
    }
  }
}

.d-orange-block {
  @media (min-width: 1550px) {
    display: block !important;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/Partnership.vue